import createRestfulModule from './restful-module'
import { actionClient } from '@/api'

export default createRestfulModule({
  actions: {
    async loadPolicy({ commit }, name){
      return await actionClient.get('policy', { query: { name } })
    },
  }
})
